import type { RouteRecordRaw } from 'vue-router';
import gettext from 'src/utils/gettext';

const { $gettext } = gettext;

// Native auth screens have their own full-bleed mobile design and layout
// (MobileAuthLayout + MobileLoginPage). Forgot-password / registration open
// the web admin portal, so only login + the reset-password deep link live here.
export const mobileAuthRoutes: RouteRecordRaw[] = [
  {
    path: '',
    name: 'login',
    component: () => import('pages/mobile/MobileLoginPage.vue'),
  },
  {
    path: 'resetpassword/:uid/:token',
    alias: $gettext('resetpassword/:uid/:token'),
    name: 'resetPassword',
    props: true,
    component: () => import('src/pages/ResetPasswordPage.vue'),
  },
];
